export enum TipoEntregaFactura {
    Email = 0,
    Fisico = 1,
    Ambos = 2
}